// TypeUser.jsx
import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
const UnselectedIcon = () => (
  <svg
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-[6px] h-[6px] md:w-[24px] md:h-[24px]"
  >
    <circle cx="8.5" cy="8.5" r="8" fill="#D9D9D9" />
  </svg>
);
const SelectedIcon = () => (
  <svg
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-[6px] h-[6px] md:w-[24px] md:h-[24px]"
  >
    <circle cx="8.5" cy="8.5" r="8" fill="#FFBD26" />
  </svg>
);

const TypeUser = ({
  label = "TYPE OF USER",
  value,
  onChange,
  required = false,
  errorMessage = "This field is required",
  isPreview = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [isTouched, setIsTouched] = useState(false);
  const dropdownRef = useRef(null);
  const contentRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);
  const [thumbHeight, setThumbHeight] = useState(40);
  const [isDragging, setIsDragging] = useState(false);
  const [startY, setStartY] = useState(0);
  const [startScrollTop, setStartScrollTop] = useState(0);
  const thumbRef = useRef(null);

  const userTypes = [
    { name: "Abattoir (ABT)", value: "Abattoir (ABT)" },
    { name: "Aggregator (AGG)", value: "Aggregator (AGG)" },
    { name: "Agrochemical (AGC)", value: "Agrochemical (AGC)" },
    { name: "Agro-Dealer (AGD)", value: "Agro-Dealer (AGD)" },
    { name: "Agronomist (AGR)", value: "Agronomist (AGR)" },
    { name: "Apiarist (APR)", value: "Apiarist (APR)" },
    { name: "Aquaculture (AQU)", value: "Aquaculture (AQU)" },
    { name: "Association (ASS)", value: "Association (ASS)" },
    { name: "Auction (ACT)", value: "Auction (ACT)" },
    { name: "Bakeries (BAK)", value: "Bakeries (BAK)" },
    { name: "Bank (BAN)", value: "Bank (BAN)" },
    { name: "Building Construction (BUC)", value: "Building Construction (BUC)" },
    { name: "Butchery (BUT)", value: "Butchery (BUT)" },
    { name: "Cafe (CAF)", value: "Cafe (CAF)" },
    { name: "Chama (CHA)", value: "Chama (CHA)" },
    { name: "Cold Logistics (COL)", value: "Cold Logistics (COL)" },
    { name: "College (CLL)", value: "College (CLL)" },
    { name: "Community Based Organization (CBO)", value: "Community Based Organization (CBO)" },
    { name: "Contract (CON)", value: "Contract (CON)" },
    { name: "Corporate Investor (COI)", value: "Corporate Investor (COI)" },
    { name: "Cooperative (COP)", value: "Cooperative (COP)" },
    { name: "Development Partner (DVP)", value: "Development Partner (DVP)" },
    { name: "Enterprise (ENT)", value: "Enterprise (ENT)" },
    { name: "Equipment Suppliers (EQS)", value: "Equipment Suppliers (EQS)" },
    { name: "Farmer (FAM)", value: "Farmer (FAM)" },
    { name: "Education (EDU)", value: "Education (EDU)" },
    { name: "Electrician (ELE)", value: "Electrician (ELE)" },
    { name: "Fish Monger (FIM)", value: "Fish Monger (FIM)" },
    { name: "Finance (FIN)", value: "Finance (FIN)" },
    { name: "Food Processing (FOP)", value: "Food Processing (FOP)" },
    { name: "Green Grocer (GRG)", value: "Green Grocer (GRG)" },
    { name: "Green House (GRH)", value: "Green House (GRH)" },
    { name: "Government (GOV)", value: "Government (GOV)" },
    { name: "Health Centre (HEC)", value: "Health Centre (HEC)" },
    { name: "Hospitals (HOS)", value: "Hospitals (HOS)" },
    { name: "Hotels (HOT)", value: "Hotels (HOT)" },
    { name: "Input Supplier (IPS)", value: "Input Supplier (IPS)" },
    { name: "Institution (INS)", value: "Institution (INS)" },
    { name: "Investor (INV)", value: "Investor (INV)" },
    { name: "Individual (IND)", value: "Individual (IND)" },
    { name: "Industry Regulator (INR)", value: "Industry Regulator (INR)" },
    { name: "Insurance (INS)", value: "Insurance (INS)" },
    { name: "Irrigation (IRR)", value: "Irrigation (IRR)" },
    { name: "Laboratory (LAB)", value: "Laboratory (LAB)" },
    { name: "Logistics (LOG)", value: "Logistics (LOG)" },
    { name: "Machinery Supplier (MH)", value: "Machinery Supplier (MH)" },
    { name: "Marketing (MAK)", value: "Marketing (MAK)" },
    { name: "Miller (MIL)", value: "Miller (MIL)" },
    { name: "Non-Governmental Organization (NGO)", value: "Non-Governmental Organization (NGO)" },
    { name: "Not for Profit Organization (NPO)", value: "Not for Profit Organization (NPO)" },
    { name: "Offtake Partner (OFP)", value: "Offtake Partner (OFP)" },
    { name: "Open Market (OPM)", value: "Open Market (OPM)" },
    { name: "Packaging (PAC)", value: "Packaging (PAC)" },
    { name: "Parliament (PAR)", value: "Parliament (PAR)" },
    { name: "Retailer (RET)", value: "Retailer (RET)" },
    { name: "Restaurant (RES)", value: "Restaurant (RES)" },
    { name: "Refrigeration (REF)", value: "Refrigeration (REF)" },
    { name: "Security (SEC)", value: "Security (SEC)" },
    { name: "Service Provider (SEP)", value: "Service Provider (SEP)" },
    { name: "Small Micro Medium Enterprises (SMME)", value: "Small Micro Medium Enterprises (SMME)" },
    { name: "Supermarkets (SUM)", value: "Supermarkets (SUM)" },
    { name: "Survey (SUR)", value: "Survey (SUR)" },
    { name: "Technical College (TEC)", value: "Technical College (TEC)" },
    { name: "Tractor (TRA)", value: "Tractor (TRA)" },
    { name: "Traders (TRD)", value: "Traders (TRD)" },
    { name: "Training (TRN)", value: "Training (TRN)" },
    { name: "University (UNI)", value: "University (UNI)" },
    { name: "Value Addition (VAA)", value: "Value Addition (VAA)" },
    { name: "Veterinary (VET)", value: "Veterinary (VET)" },
    { name: "Warehouse (WAH)", value: "Warehouse (WAH)" },
    { name: "Welfare Group (WEG)", value: "Welfare Group (WEG)" },
    { name: "School (SCH)", value: "School (SCH)" },
    { name: "Stokvel (STO)", value: "Stokvel (STO)" },
    { name: "Group (GRO)", value: "Group (GRO)" },
    { name: "Research (RES)", value: "Research (RES)" },
    { name: "Standardization (STA)", value: "Standardization (STA)" },
    { name: "Others (OOO)", value: "Others (OOO)" }
  ];

  const validate = () => {
    if (!required) return true;
    return value !== null && value !== undefined && value !== "";
  };

  const isValid = validate();
  const showError = required && isTouched && !isValid;

  useEffect(() => {
    const content = contentRef.current;
    if (!content) return;

    const updateThumbHeight = () => {
      const { scrollHeight, clientHeight } = content;
      const visibleRatio = clientHeight / scrollHeight;
      setThumbHeight(Math.max(visibleRatio * clientHeight, 20));
    };

    updateThumbHeight();
    window.addEventListener("resize", updateThumbHeight);
    return () => window.removeEventListener("resize", updateThumbHeight);
  }, [isOpen]);

  const handleScroll = () => {
    const content = contentRef.current;
    if (!content) return;

    const { scrollTop, scrollHeight, clientHeight } = content;
    const maxScrollTop = scrollHeight - clientHeight;
    const scrollRatio = scrollTop / maxScrollTop;
    const trackHeight = content.clientHeight - thumbHeight;
    setScrollTop(scrollRatio * trackHeight);
  };

  const handleThumbMouseDown = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setIsDragging(true);
    setStartY(e.clientY);
    setStartScrollTop(contentRef.current.scrollTop);

    document.addEventListener("mousemove", handleThumbMouseMove);
    document.addEventListener("mouseup", handleThumbMouseUp);
    document.body.style.cursor = "grabbing";
  };

  const handleThumbMouseMove = (e) => {
    if (!isDragging) return;

    const deltaY = e.clientY - startY;
    const content = contentRef.current;
    const { scrollHeight, clientHeight } = content;
    const maxScrollTop = scrollHeight - clientHeight;
    const trackHeight = clientHeight - thumbHeight;

    const scrollDelta = (deltaY / trackHeight) * maxScrollTop;
    const newScrollTop = Math.min(
      Math.max(0, startScrollTop + scrollDelta),
      maxScrollTop
    );

    content.scrollTop = newScrollTop;
  };

  const handleThumbMouseUp = () => {
    setIsDragging(false);
    document.removeEventListener("mousemove", handleThumbMouseMove);
    document.removeEventListener("mouseup", handleThumbMouseUp);
    document.body.style.cursor = "";
  };

  const handleTrackClick = (e) => {
    const content = contentRef.current;
    if (!content || e.target === thumbRef.current) return;

    const track = e.currentTarget;
    const trackRect = track.getBoundingClientRect();
    const clickPosition = e.clientY - trackRect.top;
    const thumbCenter = thumbHeight / 2;
    const scrollRatio =
      (clickPosition - thumbCenter) / (trackRect.height - thumbHeight);

    const { scrollHeight, clientHeight } = content;
    const maxScrollTop = scrollHeight - clientHeight;
    content.scrollTop = scrollRatio * maxScrollTop;
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleMouseEnter = () => {
    setIsOpen(true);
  };

  const handleButtonClick = () => {
    setIsTouched(true);
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (isTouched) {
      validate();
    }
  }, [value, isTouched]);

  const handleItemClick = (item) => {
    setIsTouched(true);
    onChange("USER TYPE", item);
    setIsOpen(false);
  };

  const getDisplayValue = () => {
    if (!value) return "-";
    if (typeof value === "object") {
      return value?.name || value?.value || "-"; // Use optional chaining
    }
    return value || "-";
  };

  function capitalizeWords(str) {
    return str.replace(/\b\w/g, char => char.toUpperCase());
  }

  const renderItems = () => {
    return userTypes.map((item, index) => {
      // Handle case where value is null/undefined
      const isSelected = !value ? false : 
      (typeof value === "object" 
        ? (value.name && item.name && value.name === item.name) || 
          (value.value && item.value && value.value === item.value)
        : value === item.name || value === item.value);

      return (
        <li
          key={index}
          onMouseEnter={() => setHoveredItem(item.name)}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleItemClick(item);
          }}
          className="flex justify-between items-center px-1 md:px-3 py-1 md:py-2 rounded-mdcursor-pointer relative"
        >
          <span className=" text-white   text-[4px] md:text-[16px] flex flex-col flex-1 mr-2 whitespace-normal break-words">
            {item.name}
          </span>
          <div className="flex items-center">
            {isSelected ? <SelectedIcon /> : <UnselectedIcon />}
          </div>
        </li>
      );
    });
  };

  if (isPreview) {
    return (
      <div className="flex flex-col">
        <label className="md:text-[20px] font-bold text-[5px]  text-white  mb-1 capitalize truncate">
          {label}
        </label>
        <div className="flex relative z-20 w-full">
          <button
            className={`relative xl:w-[168px] lg:w-[140px] md:w-[100px] w-full h-[20px] md:h-[53px] bg-[#2E453D] text-white flex justify-between items-center text-[4px] md:text-[17px] px-[2px] rounded-l-[4px] truncate`}
          >
            <span className={`whitespace-normal  text-white   break-words font-bold leading-[0.90] text-center capitalize w-full`}>
              {typeof value === 'object' 
                ? value?.name || value?.value || "-"
                : value || "-"}
            </span>
          </button>
          <div
            className={`w-[16px] md:w-[37px] h-[20px] md:h-[53px] bg-[#152C24] flex justify-center items-center rounded-r-[4px] -ml-1 z-30`}
          >
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="flex flex-col w-full md:mt-1 mt-1 relative "
      style={{ position: "relative", zIndex: isOpen ? 100 : 1 }}
      ref={dropdownRef}
    >
      <label className="md:text-[20px] font-bold text-[5px] text-black mb-1 capitalize truncate">
        {label}
      </label>
      {showError && (
        <span className="text-red-500 text-[3px] md:text-[12px]">
          {errorMessage}
        </span>
      )}
      <div
        className="flex relative z-20 w-full"
        onMouseEnter={handleMouseEnter}
        onClick={handleButtonClick}
      >
        <button
          className={`relative xl:w-[240px] lg:w-[140px] md:w-[100px] w-[67px] h-[15px] md:h-[53px] px-2 bg-[#152C24] text-white flex justify-between items-center text-[4px] md:text-[17px] rounded-l-[4px] truncate`}
        >
          <span className={`whitespace-normal break-words font-bold leading-[0.90] text-left capitalize w-full ${
            getDisplayValue() === "-" ? "text-gray-400" : ""
          }`}>
            {capitalizeWords(getDisplayValue())}
          </span>
        </button>
        <div
          className={`w-[20px] md:w-[50px] h-[15px] md:h-[53px] bg-[#152C24]  flex justify-center items-center rounded-r-[4px] -ml-1 z-30`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
            alt="expand"
            className="w-2 h-2 md:w-5 md:h-[24px]"
          />
        </div>
      </div>
      <p className={`text-[4px] md:text-[14px] mt-[2px] truncate ${
        showError ? "text-red-500" : "text-black"
      }`}>
        {showError ? errorMessage : "Select your user type"}
      </p>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="absolute top-full mt-1 left-0 w-full md:w-[290px] border border-[#979797]/80 bg-[#152C24] rounded shadow-lg  flex flex-col"
            style={{
              position: "absolute",
              zIndex: 1000,
              backgroundColor: "#152C24",
            }}
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
          >
            <li className="flex items-center text-white   justify-end text-[4px]  pt-1 md:text-[14px] font-semibold md:mb-2">
      
              <img
                src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1758380484/Export_1_yad3hi.png"
                alt="icon"
                className="md:w-[30px] md:h-[30px] h-[8px] w-[8px] cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsOpen(false);
                }}
              />
            </li>

       

            <div className="custom-scroll-area">
              <div
                className="custom-scroll-content"
                ref={contentRef}
                onScroll={handleScroll}
              >
                <ul className="md:px-2 ">
                  {renderItems()}
                </ul>
              </div>
              <div className="custom-scroll-track" onClick={handleTrackClick}>
                <div
                  ref={thumbRef}
                  className="custom-scroll-thumb"
                  style={{
                    height: `${thumbHeight}px`,
                    top: `${scrollTop}px`,
                    cursor: isDragging ? "grabbing" : "grab",
                  }}
                  onMouseDown={handleThumbMouseDown}
                ></div>
              </div>
            </div>

          
          </motion.div>
        )}
      </AnimatePresence>

      <style jsx>{`
        .custom-scroll-area {
          position: relative;
          max-height: 500px;
          display: flex;
          overflow: hidden;
        }

        .custom-scroll-content {
          flex: 1;
          overflow-y: scroll;
          scrollbar-width: none;
          -ms-overflow-style: none;
          padding-right: 1px;
        }

        .custom-scroll-content::-webkit-scrollbar {
          display: none;
        }

        .custom-scroll-track {
          width: 14px;
          background: #e7ebeb;
          border-radius: 3px;
          position: relative;
          margin-left: 4px;
          cursor: pointer;
        }

        .custom-scroll-thumb {
          width: 100%;
          background: #979797;
          border-radius: 3px;
          position: absolute; 
          right: 0;
          transition: background 0.2s;
        }

        .custom-scroll-thumb:hover {
          background: #444;
        }

        @media (max-width: 768px) {
          .custom-scroll-track {
            width: 4px;
            margin-left: 2px;
          }
          .custom-scroll-area {
            position: relative;
            max-height: 150px;
            display: flex;
            overflow: hidden;
            width: 100%;
          }
          .custom-scroll-content {
            flex: 1;
            overflow-y: scroll;
            scrollbar-width: none;
            -ms-overflow-style: none;
            padding-right: 0px;
          }
        }
      `}</style>
    </div>
  );
};

export default TypeUser;